var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.115,
    height: 11.83,
    viewBox: "0 0 15.115 11.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4737438_equalizer_filter_filtering_mixer_sorting_icon",
    "data-name": "4737438_equalizer_filter_filtering_mixer_sorting_icon",
    transform: "translate(-1 -5.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19197",
    "data-name": "Path 19197",
    d: "M30.215,10.657A.657.657,0,0,0,29.558,10h-6.9a.657.657,0,1,0,0,1.314h6.9A.657.657,0,0,0,30.215,10.657Z",
    transform: "translate(-14.1 -2.686)",
    fill: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19198",
    "data-name": "Path 19198",
    d: "M1.657,8.628H3.415a1.972,1.972,0,1,0,0-1.314H1.657a.657.657,0,1,0,0,1.314ZM5.272,7.314a.657.657,0,1,1-.657.657A.657.657,0,0,1,5.272,7.314Z",
    fill: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19199",
    "data-name": "Path 19199",
    d: "M32.239,19.314H29.823a1.972,1.972,0,1,0,0,1.314h2.415a.657.657,0,1,0,0-1.314Zm-4.272,1.314a.657.657,0,1,1,.657-.657A.657.657,0,0,1,27.967,20.628Z",
    transform: "translate(-16.781 -8.057)",
    fill: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19200",
    "data-name": "Path 19200",
    d: "M7.9,22H1.657a.657.657,0,1,0,0,1.314H7.9A.657.657,0,1,0,7.9,22Z",
    transform: "translate(0 -10.743)",
    fill: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19201",
    "data-name": "Path 19201",
    d: "M32.243,34H26.657a.657.657,0,0,0,0,1.314h5.586a.657.657,0,0,0,0-1.314Z",
    transform: "translate(-16.785 -18.8)",
    fill: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19202",
    "data-name": "Path 19202",
    d: "M6.586,30a1.972,1.972,0,0,0-1.857,1.314H1.657a.657.657,0,1,0,0,1.314H4.729A1.972,1.972,0,1,0,6.586,30Zm0,2.629a.657.657,0,1,1,.657-.657A.657.657,0,0,1,6.586,32.629Z",
    transform: "translate(0 -16.114)",
    fill: "#a9a9a9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilter);
export default __webpack_public_path__ + "static/media/search-filter.054e6d7bd2e9c7d6023679c84d2ef017.svg";
export { ForwardRef as ReactComponent };